import { createFileRoute } from '@tanstack/react-router';
import ActivateAccount from '../components/ActivateAccount';
import { LanguagesContext, LanguageContextProps } from '../components/LanguagesContext';

export const Route = createFileRoute('/activate-account/$token')({
  beforeLoad: () => ({ documentTitle: { main: 'loginForm.login' } }),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ActivateAccountRoute,
});

function ActivateAccountRoute() {
  return (
    <LanguagesContext.Consumer>
      {(context: LanguageContextProps) => <ActivateAccount context={context} />}
    </LanguagesContext.Consumer>
  );
}
